import Bag from './Bag.svg';
import Beret from './Beret.svg';
import Bonnet from './Bonnet.svg';
import Bow from './Bow.svg';
import Bowler from './Bowler.svg';
import Builder from './Builder.svg';
import BunnyEars from './BunnyEars.svg';
import Captain from './Captain.svg';
import Ceremonial from './Ceremonial.svg';
import Chef from './Chef.svg';
import Chinese from './Chinese.svg';
import Cowboy from './Cowboy.svg';
import Fedora from './Fedora.svg';
import Fedora2 from './Fedora2.svg';
import Fez from './Fez.svg';
import FloppyRed from './FloppyRed.svg';
import FloppySun from './FloppySun.svg';
import Floral from './Floral.svg';
import Jester from './Jester.svg';
import KidsAnimal from './KidsAnimal.svg';
import Pirate from './Pirate.svg';
import Plaid from './Plaid.svg';
import Police from './Police.svg';
import RobinHood from './RobinHood.svg';
import RoyalCrown from './RoyalCrown.svg';
import Sailor from './Sailor.svg';
import Santa from './Santa.svg';
import Scholar from './Scholar.svg';
import Sheriff from './Sheriff.svg';
import Sombrero from './Sombrero.svg';
import Spanish from './Spanish.svg';
import Straw1 from './Straw1.svg';
import Straw2 from './Straw2.svg';
import Top from './Top.svg';
import Trilby from './Trilby.svg';
import Turban1 from './Turban1.svg';
import Turban2 from './Turban2.svg';
import Turban3 from './Turban3.svg';
import Usher from './Usher.svg';
import Warden from './Warden.svg';
import Witch from './Witch.svg';

export const SpecialHatList = [
    'Builder',
    'Jester',
    'KidsAnimal',
    'RoyalCrown',
    'Usher',
    'Fez',
    'Sombrero',
    'RobinHood',
    'BunnyEars',
    'Santa',
    'Bag',
];

export const Hats = {
    // Special
    Builder,
    Jester,
    KidsAnimal,
    RoyalCrown,
    Usher,
    Fez,
    Sombrero,
    RobinHood,
    BunnyEars,
    Santa,
    Bag,
    // Rest
    Beret,
    Bonnet,
    Bowler,
    Bow,
    Captain,
    Ceremonial,
    Chef,
    Chinese,
    Cowboy,
    Fedora2,
    Fedora,
    FloppyRed,
    FloppySun,
    Floral,
    Pirate,
    Plaid,
    Police,
    Sailor,
    Scholar,
    Sheriff,
    Spanish,
    Straw1,
    Straw2,
    Top,
    Trilby,
    Turban1,
    Turban2,
    Turban3,
    Warden,
    Witch,
};
